/*
 * H&H — Mobile menu accordion (standalone asset).
 * Lives at its own path because assets/custom.js is pinned stale by a
 * query-string-insensitive CDN cache (see TODO.md Done 2026-07-06).
 * Same logic also sits in custom.js; the data-mobile-accordion-bound
 * guards make double-loading harmless.
 */

(function () {
  /*     Expand/collapse handling for nested links in the mobile drawer menu.
     The markup (toggle button + hidden panel) is rendered by
     snippets/nav-item-mobile.liquid and styled in theme.css; this is the
     behavior half. Below 990px panels start hidden and toggle open;
     at 990px and up panels render expanded and toggles are hidden by CSS.
  ============================================================================== */

  (function mobileMenuAccordion() {
    const selectors = {
      drawerMenu: '.drawer__main-menu',
      accordionItem: '[data-mobile-accordion-item]',
      accordionToggle: '[data-mobile-accordion-toggle]',
      accordionPanel: '[data-mobile-accordion-panel]',
      accordionLabel: '[data-mobile-accordion-label]',
    };

    const openClass = 'is-open';
    const desktopMedia = window.matchMedia('(min-width: 990px)');

    const setAccordionState = (item, expand = false) => {
      const toggle = item.querySelector(selectors.accordionToggle);
      const panel = item.querySelector(selectors.accordionPanel);

      if (!panel || !toggle) return;

      toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
      panel.hidden = desktopMedia.matches ? false : !expand;
      item.classList.toggle(openClass, expand);
    };

    const closeSiblingAccordions = (item) => {
      const siblings = item.parentElement?.querySelectorAll(selectors.accordionItem);
      siblings?.forEach((sibling) => {
        if (sibling !== item) {
          setAccordionState(sibling, false);
        }
      });
    };

    const toggleItem = (item) => {
      const isOpen = item.classList.contains(openClass);
      if (!isOpen) {
        closeSiblingAccordions(item);
      }
      setAccordionState(item, !isOpen);
    };

    const handleAccordionToggle = (event) => {
      const item = event.currentTarget.closest(selectors.accordionItem);
      if (!item || desktopMedia.matches) return;
      toggleItem(item);
    };

    const handleAccordionLabel = (event) => {
      const item = event.currentTarget.closest(selectors.accordionItem);
      if (!item || desktopMedia.matches) return;
      event.preventDefault();
      toggleItem(item);
    };

    const bindMobileAccordion = (scope = document) => {
      if (!scope || !scope.querySelectorAll) return;

      scope.querySelectorAll(selectors.drawerMenu).forEach((menu) => {
        menu.querySelectorAll(selectors.accordionToggle).forEach((toggle) => {
          if (toggle.dataset.mobileAccordionBound) return;
          toggle.dataset.mobileAccordionBound = 'true';
          toggle.addEventListener('click', handleAccordionToggle);
        });

        menu.querySelectorAll(selectors.accordionLabel).forEach((label) => {
          if (label.dataset.mobileAccordionBound) return;
          label.dataset.mobileAccordionBound = 'true';
          label.addEventListener('click', handleAccordionLabel);
        });

        menu.querySelectorAll(selectors.accordionItem).forEach((item) => {
          const panel = item.querySelector(selectors.accordionPanel);
          if (panel) {
            panel.hidden = !desktopMedia.matches;
          }
        });
      });
    };

    const syncAccordionToBreakpoint = () => {
      document.querySelectorAll(selectors.accordionItem).forEach((item) => {
        const panel = item.querySelector(selectors.accordionPanel);
        const toggle = item.querySelector(selectors.accordionToggle);
        if (!panel || !toggle) return;

        if (desktopMedia.matches) {
          panel.hidden = false;
          toggle.setAttribute('aria-expanded', item.classList.contains(openClass) ? 'true' : 'false');
        } else if (!item.classList.contains(openClass)) {
          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    };

    desktopMedia.addEventListener('change', syncAccordionToBreakpoint);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector(selectors.drawerMenu)) {
        bindMobileAccordion(event.target);
        syncAccordionToBreakpoint();
      }
    });

    document.addEventListener('theme:drawer:open', (event) => {
      if (event.target?.closest && event.target.closest('mobile-menu')) {
        bindMobileAccordion(event.target.closest('mobile-menu'));
        syncAccordionToBreakpoint();
      }
    });

    const init = () => {
      bindMobileAccordion();
      syncAccordionToBreakpoint();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
